import { defineComponent as A, ref as m, computed as i, watch as w, createElementBlock as v, openBlock as h, normalizeClass as s, createElementVNode as b, Fragment as S, renderList as W, normalizeStyle as $, createCommentVNode as j, createVNode as V, unref as E } from "vue";
import { RevIllustration as P } from "@ds/components/Illustration";
import { tw as e } from "../../../utils/tailwind.js";
const _ = ["aria-current", "aria-label", "onClick"], q = /* @__PURE__ */ A({
  name: "RevCarouselController",
  __name: "CarouselController",
  props: {
    buttonAriaLabel: {},
    currentIndex: {},
    intervalProgression: { default: 0 },
    autoplayRunning: { type: Boolean, default: !1 },
    imageCount: {},
    thumbnails: { default: () => [] },
    shouldThumbnailsScroll: { type: Boolean, default: !1 },
    prevButtonRef: { default: void 0 }
  },
  emits: ["select"],
  setup(c, { emit: C }) {
    const t = c, R = C, d = m({
      stateChanged: !1,
      iterations: 0
    });
    function r(a) {
      return a === t.currentIndex;
    }
    const f = i(
      () => t.thumbnails.length === t.imageCount
    );
    function T(a) {
      if (f.value) return e`focus-visible-outline-default-hi rounded-sm`;
      if (!t.autoplayRunning)
        return e`focus-visible-outline-default-hi rounded-sm size-8`;
      if (!r(a))
        return e`focus-visible-outline-default-hi rounded-sm relative size-8 items-center overflow-hidden`;
      const o = a === 0 && d.value.stateChanged && d.value.iterations === 0, u = a !== 0 || d.value.iterations > 0;
      return [
        e`bg-action-default-low focus-visible-outline-default-hi rounded-lg relative h-8 w-32 cursor-pointer items-center overflow-hidden
    border hover:bg-action-default-low-hover`,
        o && e`transition-width duration-300`,
        u && e`animate-fast-expand-translate-x-backwards transition-width duration-300`
      ];
    }
    function x(a) {
      if (!f.value && r(a) && t.autoplayRunning)
        return `width: ${t.intervalProgression * 100}%`;
    }
    const n = m(null), p = i(() => n.value?.children?.[t.currentIndex]), I = i(() => [
      t.shouldThumbnailsScroll && e`gradient-mask-lr-60 absolute inset-x-0`
    ]), L = i(() => (a) => {
      const o = f.value, u = r(a);
      return [
        e`appearance-none overflow-hidden no-underline transition-colors motion-reduce:transition-none`,
        !o && t.autoplayRunning && e`absolute`,
        r(a) && e`-inset-y-1 left-0`,
        !o && e`border-action-default-hi rounded-full size-8 border`,
        !o && u && e`bg-action-default-mid-pressed hover:bg-action-default-mid-hoverpressed`,
        !o && !u && e`bg-action-default-low hover:bg-action-default-low-hover`,
        o && e`bg-action-default-low rounded-sm flex size-40 justify-center border border-solid`,
        o && !u && e`border-action-default-low`,
        o && u && e`border-action-default-low-pressed`
      ];
    }), k = i(() => (a) => [
      e`flex`,
      !r(a) && e`opacity-50 hover:opacity-100 focus:opacity-100`
    ]), B = i(() => [
      e`flex list-none flex-row gap-8 overflow-hidden py-4`,
      t.shouldThumbnailsScroll ? e`justify-normal` : e`justify-center`,
      !f.value && e`-mx-4 p-4`
    ]), g = m(0), y = m(0);
    function N() {
      n.value !== null && (t.shouldThumbnailsScroll ? (g.value = t.prevButtonRef instanceof HTMLElement ? t.prevButtonRef.offsetWidth : 48, n.value.style.paddingLeft = `${g.value + 8}px`, n.value.style.paddingRight = `${g.value + 8}px`, y.value = p.value && p.value.offsetLeft + p.value.offsetWidth / 2 - n.value.offsetWidth / 2 || 0, n.value.scrollTo !== void 0 && n.value.scrollTo({
        left: y.value,
        behavior: "smooth"
      })) : (n.value.style.paddingLeft = "4px", n.value.style.paddingRight = "4px", n.value.style.marginRight = "-4px", n.value.style.marginLeft = "-4px"));
    }
    w(
      () => [t.currentIndex, t.shouldThumbnailsScroll],
      () => {
        N(), t.currentIndex === t.imageCount - 1 && (d.value.iterations += 1);
      }
    ), w(
      () => t.autoplayRunning,
      () => {
        d.value.stateChanged = !0;
      }
    );
    function z(a) {
      return `${t.buttonAriaLabel} ${a + 1}`;
    }
    return (a, o) => (h(), v("div", {
      class: s(I.value)
    }, [
      b("ul", {
        ref_key: "thumbnailsRef",
        ref: n,
        class: s(B.value)
      }, [
        (h(!0), v(S, null, W(c.imageCount, (u, l) => (h(), v("li", {
          key: l,
          class: "flex"
        }, [
          b("div", {
            class: s({ "w-32": r(l) && c.autoplayRunning })
          }, [
            b("button", {
              "aria-current": r(l),
              "aria-label": z(l),
              class: s(["flex", T(l)]),
              type: "button",
              onClick: () => R("select", l)
            }, [
              b("div", {
                class: s(L.value(l)),
                style: $(x(l))
              }, [
                f.value ? (h(), v("span", {
                  key: 0,
                  class: s(k.value(l))
                }, [
                  V(E(P), {
                    alt: c.thumbnails[l].alt,
                    class: "!h-40 object-cover",
                    height: 40,
                    sizes: "40px",
                    src: c.thumbnails[l].src,
                    width: 40
                  }, null, 8, ["alt", "src"])
                ], 2)) : j("", !0)
              ], 6)
            ], 10, _)
          ], 2)
        ]))), 128))
      ], 2)
    ], 2));
  }
});
export {
  q as default
};
